<template>
  <div
    style="z-index: 99999999; bottom: 50px"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
    class="toast position-fixed ms-5"
    id="main-toast"
    data-bs-autohide="false"
  >
    <div class="toast-header border-0 pb-1">
      <i class="fa-solid fa-check-circle text-primary"></i>
      <strong class="me-auto ms-2 text-subtitle">{{ title }}</strong>

      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="toast"
        aria-label="Close"
      ></button>
    </div>
    <div class="toast-body pt-0 pb-4 text-muted text-paragraph">
      <small>{{ msg }}</small>
    </div>
    <div class="progress progress-sm">
      <div
        ref="filledProgressToast"
        id="filled-progress-toast"
        class="progress-bar"
        role="progressbar"
        style="width: 100%"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { Toast } from "bootstrap";
// @ts-ignore
import $ from "jquery";
import { EventBus, EventBusNames } from "@/utils/EventBus";

const filledProgressToast = ref<HTMLElement | null>(null);
const toast = ref<Toast | null>(null);
const title = ref("");
const msg = ref("");

const handleToast = (data: { title: string; msg: string }) => {
  toast.value = new Toast(document.getElementById("main-toast")!);
  title.value = data.title;
  msg.value = data.msg;
  toast.value.show();
  $(filledProgressToast.value as HTMLElement).animate(
    { width: "0%" },
    3500,
    function () {
      setTimeout(() => {
        // @ts-ignore
        $(this).css("width", "100%");
      }, 500);
      toast.value?.hide();
    },
  );
};

onMounted(() => {
  EventBus.$on(EventBusNames.SHOW_TOAST, handleToast);
});
</script>
